// @flow
import api from 'common/services/api';
import Advertiser from 'common/modules/advertiser/domain/Advertiser';
import SalesPromotion from 'common/modules/sales/domain/SalesPromotion';

class PromotionAPI {

  buildHeaders = (token: string) => ({ Authorization: 'Bearer ' + token })

  async fetchPromotions(token: string, advertiser: Advertiser): Promise<SalesPromotion[]> {
    const requestPath = `/follo/${advertiser.getReference()}/sales-promotions`;

    const { data } = await api.get(requestPath, {}, {
      headers: this.buildHeaders(token),
    });

    return data.map(SalesPromotion.parse);
  }

  async acceptPromotion(token: string, advertiser: Advertiser, promotion: SalesPromotion) {
    const requestPath = `/follo/${advertiser.getReference()}/sales-promotions/${promotion.getReference()}/accept`;

    const { data } = await api.post(requestPath, {}, {
      headers: this.buildHeaders(token),
    });

    return SalesPromotion.parse(data);
  }

  async declinePromotion(token: string, advertiser: Advertiser, promotion: SalesPromotion) {
    const requestPath = `/follo/${advertiser.getReference()}/sales-promotions/${promotion.getReference()}/decline`;

    const { data } = await api.post(requestPath, {}, {
      headers: this.buildHeaders(token),
    });

    return SalesPromotion.parse(data);
  }
}

export default new PromotionAPI();



// WEBPACK FOOTER //
// ./src/advertisers/modules/promotions/services/PromotionAPI.js